export enum StemdoerStatus {
  ACTIVE = 'active',
  ON_TRAINING = 'onTraining',
  INACTIVE = 'inactive',
}
